export default "__VITE_ASSET__IMvvFne5__"